import { useFlags } from 'launchdarkly-react-client-sdk';
import { Plus } from 'lucide-react';
import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { appRoutes } from '../../../app-routes';
import { Button } from '../../../components/ui/button';
import type { LaunchDarklyFlags } from '../../../types/launch-darkly';
import { DescribeSegmentModal } from './describe-segment-modal/DescribeSegmentModal';
import { clearAiSegmentDraft } from './describe-segment-modal/types';

export const CreateSegmentButton: React.FC = () => {
  const navigate = useNavigate();
  const flags = useFlags<LaunchDarklyFlags>();
  const [isDescribeOpen, setIsDescribeOpen] = useState(false);

  const handleClick = () => {
    if (flags['enable-ai-segment-builder']) {
      setIsDescribeOpen(true);
      return;
    }
    clearAiSegmentDraft();
    navigate(appRoutes.ENGAGE_SEGMENTS_NEW);
  };

  return (
    <>
      <Button onClick={handleClick}>
        <Plus />
        New Segment
      </Button>
      {isDescribeOpen && <DescribeSegmentModal onClose={() => setIsDescribeOpen(false)} />}
    </>
  );
};
